<template>
  <div
    :id="id"
    class="adivare-text mt-3 mb-3"
  >
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AutoCollapseTags from "/assets/common/js/components/autoCollapseTags";

export default {
  name: "adivare-text-faq",
  props: {
    id: {
      type: String,
      required: true,
    },
    fontAwesomeVersion: {
      type: Number,
      default: 5,
      required: false,
    },
    autoCollapse: {
      type: Boolean,
      default: false,
      required: false,
    },
    autoCollapseBreakPointDown: {
      type: String,
      default: undefined,
      required: false,
    },
  },
  computed: {
    text() {
      return this.$store.state.seo.text;
    },
  },
  mounted() {
    if ('function' !== typeof $().collapse) require('bootstrap/js/dist/collapse');
    this.$nextTick(() => this.runAfterUpdate());
  },
  methods: {
    runAfterUpdate() {
      if (false === this.autoCollapse) return;
      new AutoCollapseTags({
        container: this.$el,
        breakpointDown: this.autoCollapseBreakPointDown,
        fontAwesomeVersion: this.fontAwesomeVersion,
        collapsibleHeaderTags: [
          'h3',
          'h4',
          'h5',
        ],
        nonCollapsibleHeaderTags: [
          'h1',
          'h2',
        ],
      });
    },
  },
}
</script>
